import type { FunctionComponent } from 'react';

import { CrossFlowProvider } from '@trello/cross-flow';
import type { PIIString } from '@trello/privacy';

import { TemplatesContainerLoggedIn } from './TemplatesContainerLoggedIn';
import { TemplatesContainerLoggedOut } from './TemplatesContainerLoggedOut';
import type { TemplateLanguage } from './types';

export const TemplatesContainer: FunctionComponent<{
  locale?: PIIString;
  category?: string;
  languages: TemplateLanguage[];
  shortLink?: string;
  isInAppGallery: boolean;
}> = ({ locale, category, languages, shortLink, isInAppGallery }) => {
  if (isInAppGallery) {
    return (
      <CrossFlowProvider>
        <TemplatesContainerLoggedIn
          locale={locale}
          languages={languages}
          category={category}
          shortLink={shortLink}
          isInAppGallery={isInAppGallery}
        />
      </CrossFlowProvider>
    );
  } else {
    return (
      <TemplatesContainerLoggedOut
        languages={languages}
        category={category}
        shortLink={shortLink}
        isInAppGallery={isInAppGallery}
      />
    );
  }
};
